"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateVendorPharmacyProfileSchema = exports.createVendorPharmacyProfileSchema = exports.vendorPharmacyProfileShape = void 0;
const zod_1 = require("zod");
exports.vendorPharmacyProfileShape = {
    vendorId: zod_1.z.string().uuid(),
    drugLicenseNumber: zod_1.z.string().max(50).optional(),
    drugLicenseNumber2: zod_1.z.string().max(50).optional(),
    drugLicenseExpiryDate: zod_1.z.coerce.date().optional(),
};
exports.createVendorPharmacyProfileSchema = zod_1.z.object(exports.vendorPharmacyProfileShape);
exports.updateVendorPharmacyProfileSchema = exports.createVendorPharmacyProfileSchema.partial();
//# sourceMappingURL=vendor-pharmacy-profile.schema.js.map